import {
  API_ERROR,
  NOTE_MAIN_DATA,
  NOTE_MAIN_DATA_SUCCESS,
  NOTE_CLEAR_DATA
} from "./actionTypes";

export const getMainData = () => {
  return {
    type: NOTE_MAIN_DATA,
    payload: {  },
  };
};
export const getMainDataSuccessful = (response) => {
  return {
    type:  NOTE_MAIN_DATA_SUCCESS,
    payload: response,
  };
};
export const ClearData = () => {
  return {
    type: NOTE_CLEAR_DATA,
    payload: {  },
  };
};
export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
